export const environment = {
  production: false,
  host: "https://dev.reactome.org",
  s3: "https://s3.amazonaws.com/download.reactome.org"
};
